// assets
import { DashboardOutlined, BarChartOutlined } from '@ant-design/icons';

// Define admin menu items
const admin = {
  id: 'group-dashboard',
  title: 'Admin Panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/rimash/analytics/dashboard',
      icon: DashboardOutlined
    },
    {
      id: 'analytics',
      title: 'Analytics',
      type: 'item',
      url: '/rimash/analytics/analytics',
      icon: BarChartOutlined
    },
    {
      id: 'analytics-agentive-chat',
      title: 'Agentive Chat Analytics',
      type: 'item',
      url: '/rimash/analytics/agentive-chat',
      icon: BarChartOutlined
    },
    {
      id: 'analytics-experiment-variant-chat',
      title: 'ABE Experiment Analytics',
      type: 'item',
      url: '/rimash/analytics/experiment-variant-chat',
      icon: BarChartOutlined
    },
    {
      id: 'analytics-chat-threads',
      title: 'Chat Threads',
      type: 'item',
      url: '/rimash/analytics/chat-threads',
      icon: BarChartOutlined
    },
    {
      id: 'analytics-automations',
      title: 'Automations',
      type: 'item',
      url: '/rimash/analytics/automations',
      icon: BarChartOutlined
    },
    {
      id: 'analytics-notification-testing',
      title: 'Notification Testing',
      type: 'item',
      url: '/rimash/analytics/notifications',
      icon: BarChartOutlined
    }
  ]
};

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [admin]
};

export default menuItems;
